import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { PaginationFooterTemplateComponent } from '@connect-services/client/components/pagination-footer-template/pagination-footer-template.component';
import { EntitiesTableByLayerService } from '@connect-services/client/services/entities-table-by-layer.service';
import { PanelService } from '@connect-services/client/services/panel.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { PaginatorComponent } from '@connect-services/src/lib/components/paginator/paginator.component';
import { LayerWithAttributes } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { defaultPaginationParameters, PaginationParameters } from '@shared/client/models/pagination.model';

export type ButtonProps = {
    icon: IconProp;
    labelKey: string;
};

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, PaginationFooterTemplateComponent, RessourcesModule],
    selector: 'app-field-intervention-entities-list-footer',
    templateUrl: './field-intervention-entities-list-footer.component.html',
})
export class FieldInterventionEntitiesListFooterComponent {
    public readonly activeLayers = input<LayerWithAttributes[]>([]);
    public readonly canExecuteAction = input(false);
    public readonly canSearch = input(false);
    public readonly disable = input(false);
    public readonly disableReason = input<string>();
    public readonly onPrimaryButtonClick = output<void>();
    public readonly paginationParameters = input<PaginationParameters>(defaultPaginationParameters);
    public paginator = output<PaginatorComponent>();
    public readonly primaryButtonProps = input<ButtonProps>();
    public readonly selectedEntitiesNumber = input<number>();
    public readonly selectedLayerNumber = input<number>();
    public readonly totalEntities = input<number>();
    public readonly updatedEntityNumber = input<number>();

    protected readonly ButtonType = ButtonType;
    protected readonly entitiesTableByLayerService = inject(EntitiesTableByLayerService);
    protected readonly panelService = inject(PanelService);

    public async handleSearch(searchValue: string): Promise<void> {
        this.entitiesTableByLayerService.searchValue.set(searchValue);
        await this.entitiesTableByLayerService.handleSearchFilter();
    }
}
